import { render, staticRenderFns } from "./estatisticas-andamento.vue?vue&type=template&id=777c1944&scoped=true"
import script from "./estatisticas-andamento.vue?vue&type=script&lang=js"
export * from "./estatisticas-andamento.vue?vue&type=script&lang=js"
import style0 from "./estatisticas-andamento.vue?vue&type=style&index=0&id=777c1944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777c1944",
  null
  
)

export default component.exports